import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class BarChartModule {
}
BarChartModule.ɵfac = function BarChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BarChartModule)(); };
BarChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BarChartModule });
BarChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
